<template>
  <div>
    <v-dialog v-model="mapSurquilloDialog"  width="450px">
      <v-card class="pb-6 overflow-hidden overflow-y-hidden">
        <div class="text-right">
          <v-icon @click="mapSurquilloDialog = false" color="#2800C8"
          class="px-5 py-5">mdi-close</v-icon>
        </div>
        <v-card-text>
          <component :is="mapComponent"></component>
          <p class="pl-5 pt-3 mb-0 font-weight-bold blue--text text--darken-4"
            v-for="(element, index) in directionsForMap" :key="index">
              {{ element.nameSede }}:
              <span class="font-weight-medium black--text">{{ element.direction }}</span>
            </p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import SurquilloMap from './surquillo_map.vue';

export default {
  name: 'description_service_modal',
  props: {
    value: Boolean,
  },
  components: {
    SurquilloMap,
  },
  data() {
    return {
      mapComponent: 'SurquilloMap',
      directionsForMap: [{ nameSede: 'Surquillo', direction: 'Av. República de Panamá #4575' }],
    };
  },
  computed: {

    mapSurquilloDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style scoped>
.v-dialog__content {
  overflow-x: hidden;
}

.dialog-content-container {
  width: 100%;
}
</style>
